'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unescapedText = exports.text = exports.formatDateTime = exports.abbreviateNumber = exports.parseNumber = exports.formatNumber = exports.formatPercentage = exports.formatCurrency = exports.formatName = exports.getLang = undefined;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _getLang = require('./getLang');

var _getLang2 = _interopRequireDefault(_getLang);

var _formatName = require('./formatName');

var _formatName2 = _interopRequireDefault(_formatName);

var _unescapedText = require('./unescapedText');

var _unescapedText2 = _interopRequireDefault(_unescapedText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getLang = exports.getLang = _getLang2.default;
var formatName = exports.formatName = _formatName2.default;
var formatCurrency = exports.formatCurrency = _I18n2.default.formatCurrency;
var formatPercentage = exports.formatPercentage = _I18n2.default.formatPercentage;
var formatNumber = exports.formatNumber = _I18n2.default.formatNumber;
var parseNumber = exports.parseNumber = _I18n2.default.parseNumber;
var abbreviateNumber = exports.abbreviateNumber = _I18n2.default.abbreviateNumber;
var formatDateTime = exports.formatDateTime = _I18n2.default.moment;
var text = exports.text = _I18n2.default.text;
var unescapedText = exports.unescapedText = _unescapedText2.default;